import { createAsyncThunk, createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { Company, GetCompanies } from "./companies";

interface ProductData {  
    product: string;
    cities: CompaniesByCity[];
}
export interface CompaniesByCity {
  city: string;
  cityId: number;
  companies: Company[];
}
interface ProductsState {
    data: ProductData[];
    loading: boolean;
    error: string | null;
    searchQuery: string;
    cities: Map<number, string>;
    selectedCities: number[];
}

const initialState: ProductsState = {
    // tenantIds: [],
    data: [],
    loading: false,
    error: null,
    searchQuery: "",
    cities: new Map<number, string>(),
    selectedCities: [],
};

export const fetchProductsData = createAsyncThunk(
  "products/fetchProductsData",
  async (
    payload: any,
    { rejectWithValue }
  ) => {
    try {
      let newData: {prodtype: string, city: string, cityId: number, tenant_id: number}[]  = [];
      const estateEnMap = new Map<number, {estateEn: string, estateId: number}>();
      const citiesMap = new Map<number, string>();
      for (const key in payload) {
        payload[key].forEach((item: any) => {
          const trimmedProdtype =
            typeof item.prodtype_e === "string" ? item.prodtype_e.trim() : null;
          const trimmedCity =
            typeof item.city === "string" ? item.city.trim() : null;
          if (trimmedProdtype && trimmedCity && item.tenant_id) {
            newData.push({
              prodtype:trimmedProdtype,
              city: trimmedCity,
              cityId: item.cityId,
              tenant_id: item.tenant_id
            })
            estateEnMap.set(item.tenant_id, {estateEn:trimmedCity, estateId:item.cityId});
            citiesMap.set(item.cityId, trimmedCity);
          }
        });
      }
      newData = distinct(newData)
      
      const tenantIds = Array.from(new Set(newData.map(item => item.tenant_id)));

      const companies: Company[] = (await GetCompanies(tenantIds, estateEnMap)) || [];
      // @ts-ignore
      const result = Object.entries(Object.groupBy(newData, ({ prodtype }) => prodtype))
        .map(([product, values]) => {
          // @ts-ignore
          const cities = Object.entries(Object.groupBy(values, ({ cityId }) => +cityId ))
          // @ts-ignore
            .map(([cityId, values]) => ({
              city:citiesMap.get(+cityId)!,
              cityId: +cityId,
              companies: (values ?? [])
              // @ts-ignore
                .map(t => companies.find(c => c.tenant_id === t.tenant_id)!).filter(v => v)
              }));
        return {
          product: product,
          cities: cities
        }
      });
      return { data: result, cities: citiesMap };
    } catch (error: any) {
      return rejectWithValue(error.message || "Ошибка при преобразовании данных");
    }
  }
);
export const productsSlice = createSlice({
  name: "products",
  initialState,
    reducers: {
        setSearchQuery: (state, action: PayloadAction<string>) => {
            state.searchQuery = action.payload;
        },
        setSelectedCities: (state, action: PayloadAction<number[]>) => {
            state.selectedCities = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductsData.fulfilled,
                (
                    state,
                    {payload}: PayloadAction<{ data: ProductData[]; cities: Map<number, string> }>
                ) => {
                    state.data = payload.data.sort((a, b) => a.product.replace(/^"|"$/g, "").localeCompare(b.product.replace(/^"|"$/g, "")));
                    state.cities = payload.cities;
                    state.loading = false;
                }
            )
            .addCase(fetchProductsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { setSearchQuery, setSelectedCities } = productsSlice.actions;

export default productsSlice.reducer;

const selectProducts = (state: RootState) => state.products;

export const selectFilteredTenantData = createSelector(
    [selectProducts],
    (products) => {
        const { data, searchQuery, selectedCities } = products;
        let filtered = data;

        if (searchQuery.trim()) {
            const query = searchQuery.trim().toLowerCase();
                filtered = filtered.filter((product) =>
                  product.product.toLowerCase().includes(query)
                );
        }

        if (selectedCities && selectedCities.length) {
            filtered = filtered.filter(
                (product) => product.cities.some(c=>selectedCities.includes(c.cityId))
            );
        }

        return filtered;
    }
);
export const selectProductsDataByName = createSelector(
  [
    (state: RootState) => state.products.data,
    (_: RootState, productName: string | null) => productName,
  ],
  (data: ProductData[], productName: string | null): CompaniesByCity[] => {
    if (!productName) return [];
    const product = data.find((d: any)=>d.product === productName);
    if(product) {
      return product.cities;
    }
    return [];
  }
);
function distinct<T>(array: T[]): T[]{
  const setObj = new Set(array.map(item=>JSON.stringify(item)));
  return Array.from(setObj).map(item=>JSON.parse(item))
}



